<script setup lang="ts">
  import { Pagination, PaginationType } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { computed } from 'vue';
  import {
    paginatorLoadingClass,
    paginatorWrapperClass,
  } from './DataTablePaginator.css.ts';

  export type DataTablePaginatorProps = {
    currentPage: number;
    totalItems: number;
    isLastPage: boolean;
    itemsPerPage: number;
    isFirstPage: boolean;
    loading?: boolean;
  };

  const props = defineProps<DataTablePaginatorProps>();

  const { t } = useLocale('table');

  const emits = defineEmits<{
    goToFirstPage: [];
    goToLastPage: [];
    nextPage: [];
    prevPage: [];
    goToPage: [page: number];
  }>();

  const onGoToPage = (page: number) => {
    emits('goToPage', page);
  };

  const totalPages = computed(() =>
    props.itemsPerPage > 0
      ? Math.ceil(props.totalItems / props.itemsPerPage)
      : 0,
  );

  const paginatorClasses = computed(() => ({
    [paginatorWrapperClass]: true,
    [paginatorLoadingClass]: props.loading,
  }));
</script>

<template>
  <div :class="paginatorClasses">
    <span>
      <b>{{
        `${currentPage * itemsPerPage - itemsPerPage + 1}-${
          currentPage * itemsPerPage > totalItems
            ? totalItems
            : currentPage * itemsPerPage
        }`
      }}</b>
      {{ t('table.of') }} {{ totalItems }} {{ t('table.results') }}</span
    >
    <Pagination
      :total-pages="totalPages"
      :current-page="currentPage"
      :type="PaginationType.DatasetNumbers"
      :disabled="!!loading"
      @page-change="onGoToPage"
    />
  </div>
</template>
